import { Injector } from '@angular/core';
import { Store } from '@ngxs/store';
import { TransactionState } from '@app/finxone-web-frontend/app/lib/state/transaction.state';
import { SetFormActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { FormID } from '@finxone-platform/form-action';
import { handleRedirection } from '../../cta-redirection.utils';
import {
  ActionButtonOutcomesType,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';

export function editTransactionNote(injector: Injector, widgetAttributes: UiZoneWidgetAttributeConfig) {
  const store = injector.get(Store);
  const transactionState = store.selectSnapshot(TransactionState.getTransactions);
  store.dispatch(
    new SetFormActionWithId(
      { formData: { note: transactionState.currentTransactionDetails?.note }, type: '' },
      FormID.SAVE_TRANSACTION_NOTE_FORM,
    ),
  );
  if (widgetAttributes.widgetProperties?.actionNavigationConfigurations?.[ActionButtonOutcomesType.SUCCESS]) {
    handleRedirection(widgetAttributes.widgetProperties, injector, ActionButtonOutcomesType.SUCCESS);
  }
}
